//
//
//
//
//

import varyColor from 'webpack-theme-color-replacer/client/varyColor'

let echarts;

export default {
    name: 'chart',
    props: {
        //echarts的options数据, 参考 https://www.echartsjs.com/zh/option.html
        options: Object,
        //chart高度
        height: {
            type: String,
            default: '200px'
        },
    },
    data() {
        return {
            ready: false,
        }
    },
    watch: {
        options(options) {
            this.setOptionD(options);
        }
    },
    created() {
        //echarts太大，改异步加载
        require([
            // 引入基本模板
            'echarts/lib/echarts',
            // 按需引入组件
            'echarts/lib/chart/bar',
            'echarts/lib/chart/line',
            'echarts/lib/chart/pie',
            'echarts/lib/component/tooltip',
            'echarts/lib/component/legend',
            //'echarts/lib/component/title'
        ], ret => {
            echarts = ret
            this.ready = true
            this.setOptionD(this.options)
        })
        this.setOptionD = this.$x.debounce(100, this.setOption);
    },
    destroyed() {
        this.chart = null;
    },
    methods: {
        // pubSetOption(options) {
        //     this.chart.setOption(options)
        // },
        setOption(options) {
            if (options && this.ready) {
                this.parseGradient(options)
                if (!this.chart) this.chart = echarts.init(this.$el);
                this.chart.setOption(options);
            }
        },
        parseGradient(options) {
            var series = options.series || [];
            [].concat(series).map(s => {
                transColor(s)
                var data = s.data || []
                if (data.map) data.map(transColor)
            })

            function transColor(obj) {
                var style = obj && obj.itemStyle;
                if (style && style.color) {
                    style.color = new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        { offset: 0, color: varyColor.lighten(style.color, 0.5) },
                        { offset: 1, color: style.color }
                    ])
                }
            }
        }
    },
}
